<template>
  <div class="identify-code" @click="handleClick">
    <span 
      v-for="(char, index) in identifyCode" 
      :key="index" 
      class="code-char"
      :style="{ animationDelay: `${index * 0.1}s` }"
    >
      {{ char }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'IdentifyCode',
  props: {
    identifyCode: {
      type: String,
      default: '1234'
    }
  },
  methods: {
    handleClick() {
      this.$emit('refresh');
    }
  }
};
</script>

<style lang="scss" scoped>
.identify-code {
  width: 116px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: linear-gradient(135deg, #F0F8FD 0%, #E5F3FB 100%);
  border: 1px solid #C9E5F7;
  border-radius: 12px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s;
  }
  
  &:hover {
    background: linear-gradient(135deg, #E8F5FC 0%, #D9EEFA 100%);
    border-color: #B5D9F0;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(19,149,219,0.12);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0);
  }
}

.code-char {
  color: #1395DB;
  font-size: 24px;
  font-weight: 700;
  font-family: 'Arial', 'Helvetica', sans-serif;
  line-height: 1;
  display: inline-block;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
